import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/MyContext";
import { Button } from "@/components/ui/button";
import { Menu, X, Shield } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Admin, useLogin, useNotify } from "react-admin";
import { dataProvider, supabase } from "@/lib/supabase";
import authProvider from "@/lib/adminAuthProvider";
import Adminsignin from "./admin/adminsignin";

const Navigation: React.FC = () => {
  const { user, logout, adminLogin } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [adminEmail, setAdminEmail] = useState("support@applaunchai.com");
  const [adminPassword, setAdminPassword] = useState("");
  const [adminLoginLoading, setAdminLoginLoading] = useState(false);
  const [adminDialogOpen, setAdminDialogOpen] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  // const login = useLogin();
  // const notify = useNotify();

  useEffect(() => {
    // (async () => {
    //   const user = await supabase.auth.getUser();
    //   console.log(user);
    //   if (user.data.user) {
    //     setLoggedIn(true);
    //   }
    // })();
    // console.log(user);
    // if (user) {
    //   setLoggedIn(true);
    // } else {
    //   setLoggedIn(false);
    // }
    if(user){
      setLoggedIn(true);
    } else{
      setLoggedIn(false);
    }
  }, [user]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleLogout = async () => {
    try {
      // const { error } = await supabase.auth.signOut();
      // if (error) throw error;
      await logout();
      navigate("/");
      setLoggedIn(false);
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  // const handleAdminLogin = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   try {
  //     setAdminLoginLoading(true);
  //     // await adminLogin(adminEmail, adminPassword);
  //     await login({adminEmail, adminPassword}); 
  //     setAdminDialogOpen(false);
  //     navigate("/admin");
  //   } catch (error) {
  //     notify('Invalid email or password', { type: 'error' });
  //     console.error("Admin login failed", error);
  //   } finally {
  //     setAdminLoginLoading(false);
  //   }
  // };

  return (
    <header className="bg-white py-4 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src="/lovable-uploads/e8744470-4d22-410f-8465-50d77f19a568.png"
              alt="AppLaunchAI Logo"
              className="h-20"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-10">
         {!user?.isAdmin && 
         <>
            <Link
              to="/pricing"
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
            >
              Pricing
            </Link>
            <Link
              to="/about"
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
            >
              About
            </Link>
            <Link
              to="/faq"
              className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
            >
              FAQ
            </Link>
            </>}
            {/* jjjj */}
            {loggedIn ? (
              <>
               {!user?.isAdmin &&  <Link
                  to="/dashboard"
                  className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
                >
                  Dashboard
                </Link>}
                {/* {user.isAdmin && (
                  <Link to="/admin" className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
                    Admin Panel
                  </Link>
                )} */}
                <Button
                  onClick={handleLogout}
                  variant="outline"
                  size="sm"
                  className="ml-4"
                >
                  Log Out
                </Button>
              </>
            ) : (
              <div className="flex items-center space-x-4">
                <Link
                  to="/login"
                  className="text-gray-700 hover:text-blue-600 transition-colors font-medium"
                >
                  Login
                </Link>
                <Link to="/signup">
                  <Button
                    size="sm"
                    className="bg-orange-500 hover:bg-orange-600 text-white"
                  >
                    Sign Up
                  </Button>
                </Link>

                {/* Admin Login Dialog */}
                <Dialog
                  open={adminDialogOpen}
                  onOpenChange={setAdminDialogOpen}
                >
                  <DialogTrigger asChild>
                    {/* <Link to="/admin?/login"> */}
                    <Button
                      size="sm"
                      variant="outline"
                      className="ml-2 flex items-center gap-1"
                    >
                      <Shield size={16} />
                      Admin
                    </Button>
                    {/* </Link> */}
                  </DialogTrigger>
                  {/* <Admin authProvider={authProvider} dataProvider={dataProvider} loginPage={Adminsignin}></Admin> */}
                  <Adminsignin onClose={() => setAdminDialogOpen(false)} />
                 
                </Dialog>
              </div>
            )}
          </nav>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              type="button"
              className="p-2 text-gray-700 focus:outline-none"
              onClick={toggleMobileMenu}
            >
              {mobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={cn(
          "fixed inset-0 z-50 bg-white pt-20 px-6 flex flex-col transition-transform duration-300 md:hidden",
          mobileMenuOpen
            ? "transform translate-x-0"
            : "transform translate-x-full"
        )}
      >
        {!user?.isAdmin && <><Link
          to="/pricing"
          className="py-3 border-b border-gray-100 text-gray-700"
          onClick={toggleMobileMenu}
        >
          Pricing
        </Link>
        <Link
          to="/about"
          className="py-3 border-b border-gray-100 text-gray-700"
          onClick={toggleMobileMenu}
        >
          About
        </Link>
        <Link
          to="/faq"
          className="py-3 border-b border-gray-100 text-gray-700"
          onClick={toggleMobileMenu}
        >
          FAQ
        </Link></>}
        {user ? (
          <>
            {!user?.isAdmin && <Link
              to="/dashboard"
              className="py-3 border-b border-gray-100 text-gray-700"
              onClick={toggleMobileMenu}
            >
              Dashboard
            </Link>}
            {user?.isAdmin && (
              <Link
                to="/admin"
                className="py-3 border-b border-gray-100 text-gray-700"
                onClick={toggleMobileMenu}
              >
                Admin Panel
              </Link>
            )}
            <Button
              onClick={() => {
                handleLogout();
                toggleMobileMenu();
              }}
              variant="outline"
              className="mt-4"
            >
              Log Out
            </Button>
          </>
        ) : (
          <div className="flex flex-col space-y-3 mt-3">
            <Link
              to="/login"
              className="py-2 text-gray-700 border border-gray-200 rounded-md text-center"
              onClick={toggleMobileMenu}
            >
              Login
            </Link>
            <Link
              to="/signup"
              className="py-2 bg-orange-500 text-white rounded-md text-center"
              onClick={toggleMobileMenu}
            >
              Sign Up
            </Link>
            <Button
              variant="outline"
              className="py-2 flex justify-center items-center gap-1"
              onClick={() => {
                toggleMobileMenu();
                setAdminDialogOpen(true);
              }}
            >
              <Shield size={16} />
              Admin Login
            </Button>
          </div>
        )}
      </div>

      {/* Overlay for mobile menu */}
      {mobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
          onClick={toggleMobileMenu}
        />
      )}

      {/* Admin Dialog for Mobile - Shows outside of mobile menu */}
      {/* <Dialog open={adminDialogOpen} onOpenChange={setAdminDialogOpen}>
        <DialogContent className="sm:max-w-[425px]">
          <DialogHeader>
            <DialogTitle>Admin Login</DialogTitle>
          </DialogHeader>
          <form onSubmit={handleAdminLogin} className="space-y-4 pt-2">
            <div className="space-y-2">
              <Label htmlFor="mobile-admin-email">Email</Label>
              <Input
                id="mobile-admin-email"
                value={adminEmail}
                onChange={(e) => setAdminEmail(e.target.value)}
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="mobile-admin-password">Password</Label>
              <Input
                id="mobile-admin-password"
                type="password"
                value={adminPassword}
                onChange={(e) => setAdminPassword(e.target.value)}
                required
              />
            </div>
            <Button
              type="submit"
              className="w-full"
              disabled={adminLoginLoading}
            >
              {adminLoginLoading ? "Logging in..." : "Login as Admin"}
            </Button>
          </form>
        </DialogContent>
      </Dialog> */}
    </header>
  );
};

export default Navigation;
